module.exports = __webpack_public_path__ + "img/08 Gazela.b7192241.png";